module.exports = __webpack_public_path__ + "panel/img/FEELLINE.fababe2f.png";